import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    if (state) {
      Object.assign(state, state.getDefaultState());
    }
  },
  setLoading: set("loading"),
  setInstallmentsGroups: set("installmentsGroups"),
  setDebtBillings: set("debtBillings"),
};
